// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__2XJY6","item":"Breadcrumbs_item__pS8QQ","separator":"Breadcrumbs_separator__Pd8yy"};